var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_231",
    "data-name": "Group 231",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.732,
    height: 18,
    viewBox: "0 0 19.732 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M272.4,206.145c.159-.2.307-.412.48-.589q1.849-1.878,3.707-3.744,1.421-1.431,2.846-2.856c.629-.632,1.253-1.274,1.887-1.9a1.293,1.293,0,0,1,1.9.008c.958.958,1.908,1.927,2.863,2.891.019.019.041.034.088.073.006-.092.013-.156.013-.221q0-1.248,0-2.5c0-.471.121-.618.506-.618q1.063,0,2.127,0c.363,0,.492.157.493.6q0,2.85,0,5.7a.45.45,0,0,0,.137.356q1.214,1.21,2.422,2.43a2.819,2.819,0,0,1,.263.37v.267c-.258.382-.514.766-.773,1.147-.224.327-.425.356-.7.081-.735-.736-1.465-1.48-2.2-2.22q-.967-.975-1.935-1.948l-1.995-2.011q-1.076-1.086-2.149-2.174c-.083-.085-.143-.088-.228,0q-.979,1-1.966,1.993l-1.96,1.973-1.97,1.987-2.2,2.217c-.084.086-.167.175-.256.252a.336.336,0,0,1-.56-.068c-.287-.4-.561-.818-.84-1.228Z",
    transform: "translate(-272.397 -196.644)",
    fill: "#828282"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M283.794,215.622v-5.658c-.069,0-.119-.009-.169-.009-.909,0-1.818,0-2.727,0-.136,0-.173.044-.173.212.006,1.735,0,3.47,0,5.206v.269h-4.5c-.555,0-.86-.373-.861-1.059q0-3.423,0-6.845a.486.486,0,0,1,.156-.382c1.064-1.077,2.122-2.162,3.183-3.244q1.4-1.428,2.8-2.853c.248-.254.495-.51.75-.772l1.112,1.133q1.61,1.64,3.218,3.28,1.234,1.259,2.466,2.522a.4.4,0,0,1,.091.242q.007,3.507,0,7.016c0,.564-.316.956-.767.958-1.5.008-3,0-4.5,0A.857.857,0,0,1,283.794,215.622Z",
    transform: "translate(-272.397 -197.639)",
    fill: "#828282"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a5fa3720e710601e8e94fc415422ddfb.svg";
export { ForwardRef as ReactComponent };